export const GET_DOCUMENT_LIST_REQUEST = "GET_DOCUMENT_LIST_REQUEST";
export const GET_DOCUMENT_LIST_SUCCESS = "GET_DOCUMENT_LIST_SUCCESS";
